import React from 'react';

const Page = (props, { tw }) => {
  return <section className={`py-7 px-7 ${tw}`}>{props.children}</section>;
};

export default Page;
